import React, { useEffect, useState } from 'react';
import { cellRendererCheck, dateFormate, currencyFormat } from 'utils/columns';
import ReactStrapTable from 'components/reactStrapTable';
import { useNavigate } from 'react-router-dom';
import useAxios from 'hooks/useAxios';
import DragDrop from 'components/DragDrop';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { onExport } from 'utils/helper';
import { ModuleAccess } from 'utils/moduleaccess';
import useContextService from 'hooks/useContextService';

//import { } from 'reactstrap';

let modulename = "ReplenishedClaimReports";

let currencylist = ['totalPayment', 'Copay', 'Insurance Payment', 'Total Paid', 'Dispense Fee', 'Est WAC Retail Cost'];
let dateList = ['Switch Date', 'Claim Captured Date', 'Service Date', 'Written Date', 'Patient DOB'];
let numberlist = ['PO Number', 'Source PO#', 'Total Packages Ordered', 'Total Ordered Price', 'Total Invoiced Packages','Rx #','Refill #','Pharmacy NABP or NPI','NDC','Qty','Dispense Fee']
let hideColFilterlist = ['Pharmacy NABP or NPI','Rx #','Refill #','Service Date','NDC','Qty','Dispense Fee']
let isRole = ["GWPHA", "GWPHU"]
let autoselectlist1 = [];
let widthList = ['Covered Entity', 'Pharmacy Name', 'Reason', 'Drug Name','Member ID']


let tableDataBackup = [];
const ReportReplenishedTable = (props) => {
  const {
    data,
    loading,
    totalSize,
    onPageChange,
    filters,
    onSearchColumnFilters = () => '',
    AllExport,
    slelectedExportReplenishedcoloumms,
    thirdPartyAdmin,
    enableAdd,
    refetch,
    tenantID,
    pageFilters,
    toggleSider,
    collapseSider,
    
  } = props;
  const API = useAxios();
  const {
    states: { ReplenishedClaimReports },
    setStates,
    resetStates,
  } = useContextService();

  const { search, searchTerms } =
    ReplenishedClaimReports;
  const { ceIds, pharmacyids } =
    searchTerms;
  useEffect(() => {
    handlAutocoloms();
  }, []);


  tableDataBackup = data;
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(tableDataBackup);
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const [coloumselect, setColoumselect] = useState(false);
  const [reset, setReset] = useState(false);
  const [disableSelectedColumn, setDisableSelectedColumn] = useState(false);
  const { token_type, access_token, profile } =
    JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  const [isOpen, setIsOpen] = useState(false);
  const [state, updateState] = useState({
    tableData: [],
    backUpData: [],
    filters: filters,
  });
  const { roles } = profile || {};
  console.log(roles, "roles")
  var con = isRole.includes(roles);
  console.log(con, "con")
  const handleselectColoums = () => {
    setColoumselect(!coloumselect);
  }

  useEffect(() => {
    setHasExportPermission(ModuleAccess("REP", "EXP"));
  }, []);


  const handlAutocoloms = async () => {
    autoselectlist1 = [];
    try {
      const { data } = await API.get(`GWConfig/coveredentity/autoselectcoloumslist/${modulename}`, {
        hasDefaultURL: true,
      });
      if (data) {
        if(data.length>0){
          setDisableSelectedColumn(false);
        }else{
          setDisableSelectedColumn(true);
        }
        for (var x in data) {
          autoselectlist1.push({ "text": data[x].displayName, "dataField": data[x].fieldName });

        }
      }

    } catch (err) {

    }
  }

  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  // const onHandleSort = (filter, hasColFilter) => {
  //   if (hasColFilter) {
  //     onPageChange(filter, true);
  //   } else {
  //     onPageChange(filter);
  //   }
  // };
  const cellOptionLink = (rowData) => {
    if (rowData.poStatusID == 5070) {
      return (
        <Button color='link' onClick={() => handleClaimsPO(rowData)}>
          <HoverImage src={ViewClaimsHover} hoverSrc={ViewClaimsHover} alt />
        </Button>
      );
    }
  };

  const handleSort = (filter, hasColFilter) => {
    setState({
      filters: filter,
    });
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
    useEffect(() => {
        setState({ tableData: data, backUpData: data });
      }, [data]);
  useEffect(() => {
    setState({ tableData: data, backUpData: data });
  }, [data]);
  const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
    }
  };

  const cellRenderLink = (rowData) => {
    return (
      <span
        className='text-decoration-underline d-inline-block cursor-pointer'
      //onClick={() => handlePODetails(rowData)}
      >
        {rowData.poid}
      </span>
    );
  };

  const handleFilterCancel = () => {
    
    refetch(true);
  };
  let maincol1 = [
    {
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellOptionLink(rowData),
      action: true,
    },

    {
      dataField: autoselectlist1[0]?.dataField,
      text: autoselectlist1[0]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[0]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[0]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[0]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 0 ? true : false,
      inputType: dateList.includes(autoselectlist1[0]?.text) ? "date" : numberlist.includes(autoselectlist1[0]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[0]?.text) ? 288 : 144,
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[1]?.dataField,
      text: autoselectlist1[1]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[1]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[1]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[1]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthList.includes(autoselectlist1[1]?.text) ? 288 : 144,
      show: autoselectlist1.length > [1] ? true : false,
      inputType: dateList.includes(autoselectlist1[1]?.text) ? "date" : numberlist.includes(autoselectlist1[1]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[2]?.dataField,
      text: autoselectlist1[2]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[2]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[2]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[2]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [2] ? true : false,
      inputType: dateList.includes(autoselectlist1[2]?.text) ? "date" : numberlist.includes(autoselectlist1[2]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[2]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[3]?.dataField,
      text: autoselectlist1[3]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[3]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[3]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[3]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      sort: hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
      show: autoselectlist1.length > [3] ? true : false,
      inputType: dateList.includes(autoselectlist1[3]?.text) ? "date" : numberlist.includes(autoselectlist1[3]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
      action: true,
      width: widthList.includes(autoselectlist1[3]?.text) ? 288 : 144,
      edit: false,
    },
    {
      dataField: autoselectlist1[4]?.dataField,
      text: autoselectlist1[4]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[4]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[4]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[4]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthList.includes(autoselectlist1[4]?.text) ? 288 : 144,
      show: autoselectlist1.length > [4] ? true : false,
      inputType: dateList.includes(autoselectlist1[4]?.text) ? "date" : numberlist.includes(autoselectlist1[4]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[5]?.dataField,
      text: autoselectlist1[5]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[5]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[5]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[5]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [5] ? true : false,
      inputType: dateList.includes(autoselectlist1[5]?.text) ? "date" : numberlist.includes(autoselectlist1[5]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[5]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[6]?.dataField,
      text: autoselectlist1[6]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[6]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[6]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[6]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [6] ? true : false,
      inputType: dateList.includes(autoselectlist1[6]?.text) ? "date" : numberlist.includes(autoselectlist1[6]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[6]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[7]?.dataField,
      text: autoselectlist1[7]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[7]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[7]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[7]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [7] ? true : false,
      inputType: dateList.includes(autoselectlist1[7]?.text) ? "date" : numberlist.includes(autoselectlist1[7]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[7]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[8]?.dataField,
      text: autoselectlist1[8]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[8]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[8]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[8]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [8] ? true : false,
      inputType: dateList.includes(autoselectlist1[8]?.text) ? "date" : numberlist.includes(autoselectlist1[8]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[8]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[9]?.dataField,
      text: autoselectlist1[9]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[9]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[9]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[9]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthList.includes(autoselectlist1[9]?.text) ? 288 : 144,
      show: autoselectlist1.length > [9] ? true : false,
      inputType: dateList.includes(autoselectlist1[9]?.text) ? "date" : numberlist.includes(autoselectlist1[9]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[10]?.dataField,
      text: autoselectlist1[10]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[10]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[10]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[10]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthList.includes(autoselectlist1[10]?.text) ? 288 : 144,
      show: autoselectlist1.length > [10] ? true : false,
      inputType: dateList.includes(autoselectlist1[10]?.text) ? "date" : numberlist.includes(autoselectlist1[10]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[11]?.dataField,
      text: autoselectlist1[11]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[11]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[11]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[11]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [11] ? true : false,
      inputType: dateList.includes(autoselectlist1[11]?.text) ? "date" : numberlist.includes(autoselectlist1[11]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[11]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[12]?.dataField,
      text: autoselectlist1[12]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[12]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[12]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[12]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [12] ? true : false,
      inputType: dateList.includes(autoselectlist1[12]?.text) ? "date" : numberlist.includes(autoselectlist1[12]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[12]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,

    },
    {
      dataField: autoselectlist1[13]?.dataField,
      text: autoselectlist1[13]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[13]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[13]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[13]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [13] ? true : false,
      inputType: dateList.includes(autoselectlist1[13]?.text) ? "date" : numberlist.includes(autoselectlist1[13]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[13]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[14]?.dataField,
      text: autoselectlist1[14]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[14]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[14]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[14]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [14] ? true : false,
      inputType: dateList.includes(autoselectlist1[14]?.text) ? "date" : numberlist.includes(autoselectlist1[14]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[14]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[15]?.dataField,
      text: autoselectlist1[15]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[15]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[15]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[15]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [15] ? true : false,
      inputType: dateList.includes(autoselectlist1[15]?.text) ? "date" : numberlist.includes(autoselectlist1[15]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[15]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[16]?.dataField,
      text: autoselectlist1[16]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[16]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[16]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[16]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [16] ? true : false,
      inputType: dateList.includes(autoselectlist1[16]?.text) ? "date" : numberlist.includes(autoselectlist1[16]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[16]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[17]?.dataField,
      text: autoselectlist1[17]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[17]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[17]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[17]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [17] ? true : false,
      inputType: dateList.includes(autoselectlist1[17]?.text) ? "date" : numberlist.includes(autoselectlist1[17]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[17]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[17]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[17]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[18]?.dataField,
      text: autoselectlist1[18]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[18]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[18]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[18]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [18] ? true : false,
      inputType: dateList.includes(autoselectlist1[18]?.text) ? "date" : numberlist.includes(autoselectlist1[18]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[18]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[18]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[18]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[19]?.dataField,
      text: autoselectlist1[19]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[19]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[19]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[19]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [19] ? true : false,
      inputType: dateList.includes(autoselectlist1[19]?.text) ? "date" : numberlist.includes(autoselectlist1[19]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[19]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[19]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[19]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[20]?.dataField,
      text: autoselectlist1[20]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[20]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[20]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[20]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [20] ? true : false,
      inputType: dateList.includes(autoselectlist1[20]?.text) ? "date" : numberlist.includes(autoselectlist1[20]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[20]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[20]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[20]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[21]?.dataField,
      text: autoselectlist1[21]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[21]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[21]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[21]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [21] ? true : false,
      inputType: dateList.includes(autoselectlist1[21]?.text) ? "date" : numberlist.includes(autoselectlist1[21]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[21]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[21]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[21]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[22]?.dataField,
      text: autoselectlist1[22]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[22]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[22]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[22]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [22] ? true : false,
      inputType: dateList.includes(autoselectlist1[22]?.text) ? "date" : numberlist.includes(autoselectlist1[22]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[22]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[22]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[22]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[23]?.dataField,
      text: autoselectlist1[23]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[23]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[23]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[23]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [23] ? true : false,
      inputType: dateList.includes(autoselectlist1[23]?.text) ? "date" : numberlist.includes(autoselectlist1[23]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[23]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[23]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[23]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[24]?.dataField,
      text: autoselectlist1[24]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[24]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[24]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[24]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [24] ? true : false,
      inputType: dateList.includes(autoselectlist1[24]?.text) ? "date" : numberlist.includes(autoselectlist1[24]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[24]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[24]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[24]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[25]?.dataField,
      text: autoselectlist1[25]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[25]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[25]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[25]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [25] ? true : false,
      inputType: dateList.includes(autoselectlist1[25]?.text) ? "date" : numberlist.includes(autoselectlist1[25]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[25]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[25]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[25]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[26]?.dataField,
      text: autoselectlist1[26]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[26]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[26]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[26]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [26] ? true : false,
      inputType: dateList.includes(autoselectlist1[26]?.text) ? "date" : numberlist.includes(autoselectlist1[26]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[26]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[26]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[26]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[27]?.dataField,
      text: autoselectlist1[27]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[27]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[27]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[27]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [27] ? true : false,
      inputType: dateList.includes(autoselectlist1[27]?.text) ? "date" : numberlist.includes(autoselectlist1[27]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[27]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[27]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[27]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[28]?.dataField,
      text: autoselectlist1[28]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[28]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[28]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[28]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [28] ? true : false,
      inputType: dateList.includes(autoselectlist1[28]?.text) ? "date" : numberlist.includes(autoselectlist1[28]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[28]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[28]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[28]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[29]?.dataField,
      text: autoselectlist1[29]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[29]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[29]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[29]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [29] ? true : false,
      inputType: dateList.includes(autoselectlist1[29]?.text) ? "date" : numberlist.includes(autoselectlist1[29]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[29]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[29]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[29]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[30]?.dataField,
      text: autoselectlist1[30]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[30]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[30]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[30]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [30] ? true : false,
      inputType: dateList.includes(autoselectlist1[30]?.text) ? "date" : numberlist.includes(autoselectlist1[30]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[30]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[30]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[30]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[31]?.dataField,
      text: autoselectlist1[31]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[31]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[31]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[31]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [31] ? true : false,
      inputType: dateList.includes(autoselectlist1[31]?.text) ? "date" : numberlist.includes(autoselectlist1[31]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[31]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[31]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[31]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[32]?.dataField,
      text: autoselectlist1[32]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[32]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[32]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[32]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [32] ? true : false,
      inputType: dateList.includes(autoselectlist1[32]?.text) ? "date" : numberlist.includes(autoselectlist1[32]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[32]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[32]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[32]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[33]?.dataField,
      text: autoselectlist1[33]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[33]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[33]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[33]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [33] ? true : false,
      inputType: dateList.includes(autoselectlist1[33]?.text) ? "date" : numberlist.includes(autoselectlist1[33]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[33]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[33]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[33]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[34]?.dataField,
      text: autoselectlist1[34]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[34]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[34]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[34]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [34] ? true : false,
      inputType: dateList.includes(autoselectlist1[34]?.text) ? "date" : numberlist.includes(autoselectlist1[34]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[34]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[34]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[34]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[35]?.dataField,
      text: autoselectlist1[35]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[35]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[35]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[35]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [35] ? true : false,
      inputType: dateList.includes(autoselectlist1[35]?.text) ? "date" : numberlist.includes(autoselectlist1[35]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[35]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[35]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[35]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[36]?.dataField,
      text: autoselectlist1[36]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[36]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[36]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[36]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [36] ? true : false,
      inputType: dateList.includes(autoselectlist1[36]?.text) ? "date" : numberlist.includes(autoselectlist1[36]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[36]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[36]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[36]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[37]?.dataField,
      text: autoselectlist1[37]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[37]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[37]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[37]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [37] ? true : false,
      inputType: dateList.includes(autoselectlist1[37]?.text) ? "date" : numberlist.includes(autoselectlist1[37]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[37]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[37]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[37]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[38]?.dataField,
      text: autoselectlist1[38]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[38]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[38]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[38]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [38] ? true : false,
      inputType: dateList.includes(autoselectlist1[38]?.text) ? "date" : numberlist.includes(autoselectlist1[38]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[38]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[38]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[38]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[39]?.dataField,
      text: autoselectlist1[39]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[39]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[39]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[39]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [39] ? true : false,
      inputType: dateList.includes(autoselectlist1[39]?.text) ? "date" : numberlist.includes(autoselectlist1[39]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[39]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[39]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[39]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[40]?.dataField,
      text: autoselectlist1[40]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[40]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[40]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[40]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [40] ? true : false,
      inputType: dateList.includes(autoselectlist1[40]?.text) ? "date" : numberlist.includes(autoselectlist1[40]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[40]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[40]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[40]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[41]?.dataField,
      text: autoselectlist1[41]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[41]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[41]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[41]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [41] ? true : false,
      inputType: dateList.includes(autoselectlist1[41]?.text) ? "date" : numberlist.includes(autoselectlist1[41]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[41]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[41]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[41]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[42]?.dataField,
      text: autoselectlist1[42]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[42]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[42]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[42]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [42] ? true : false,
      inputType: dateList.includes(autoselectlist1[42]?.text) ? "date" : numberlist.includes(autoselectlist1[42]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[42]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[42]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[42]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[43]?.dataField,
      text: autoselectlist1[43]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[43]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[43]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[43]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [43] ? true : false,
      inputType: dateList.includes(autoselectlist1[43]?.text) ? "date" : numberlist.includes(autoselectlist1[43]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[43]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[43]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[43]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[44]?.dataField,
      text: autoselectlist1[44]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[44]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[44]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[44]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [44] ? true : false,
      inputType: dateList.includes(autoselectlist1[44]?.text) ? "date" : numberlist.includes(autoselectlist1[44]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[44]?.text) ? true : false,
      width: widthList.includes(autoselectlist1[44]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[44]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[45]?.dataField,
      text: autoselectlist1[45]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[45]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[45]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[45]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [45] ? true : false,
      inputType: dateList.includes(autoselectlist1[45]?.text) ? "date" : numberlist.includes(autoselectlist1[45]?.text) ? "number" : "text",
      width: widthList.includes(autoselectlist1[45]?.text) ? 288 : 144,
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[45]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[45]?.text) ? true : false,
    },
    
    {
      dataField: autoselectlist1[46]?.dataField,
      text: autoselectlist1[46]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[46]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[46]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[46]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [46] ? true : false,
      inputType: dateList.includes(autoselectlist1[46]?.text) ? "date" : numberlist.includes(autoselectlist1[46]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[46]?.text) ? true : false,
      width:  widthList.includes(autoselectlist1[46]?.text) ? 288 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[46]?.text) ? true : false,
    },


  ];
  

  let mainCol = [
    {
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      hideColFilter: true,
      action: true
    },
    {
      dataField: 'coveredEntity',
      text: 'Covered Entity',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData) => cellRendererCheck(rowData.coveredEntity),
    },

    {
      dataField: 'pharmacyName',
      text: 'Pharmacy Name',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'storeNPI',
      text: 'Pharmacy NABP or NPI',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'transactionCode',
      text: 'Transaction Code',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'bin',
      text: 'BIN',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'pcn',
      text: 'PCN',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'group',
      text: 'Group',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'secondaryBin',
      text: 'Secondary BIN',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'secondaryPcn',
      text: 'Secondary PCN',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'secondaryGroupNumber',
      text: 'Secondary Group Number',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'occ',
      text: 'Other Coverage Code',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'scc',
      text: 'Submission Clarification Code',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'prescriptionNumber',
      text: 'Rx #',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'fillNumber',
      text: 'Refill #',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'switchDate',
      text: 'Switch Date',
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),

    },
    {
      dataField: 'dateRxwritten',
      text: 'Written Date',
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),

    },
    {
      dataField: 'dateOfDispense',
      text: 'Service Date',
      sort: true,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: false,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),

    },
    {
      dataField: 'createdDate',
      text: 'Claim Captured Date',
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),

    },
    {
      dataField: 'mrn',
      text: 'MRN ',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'insuranceMemberID',
      text: 'Member ID',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'patientFirstName',
      text: 'Patient First Name',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'patientLastName',
      text: 'Patient Last Name',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'patientGender',
      text: 'Patient Gender',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'patientDob',
      text: 'Patient DOB',
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),

    },
    {
      dataField: 'prescriberFirstName',
      text: 'Prescriber First Name',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'prescriberLastName',
      text: 'Prescriber Last Name',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'prescriberNpi',
      text: 'Prescriber NPI',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'ndc',
      text: 'NDC',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'drugDescription',
      text: 'Drug Name',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'drugManufacturerName',
      text: 'Mfg. Name',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'brandGenericFlag',
      text: 'Brand or Generic',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'quantity',
      text: 'Qty',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'daysSupply',
      text: 'Days Supply',
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'patientPay',
      text: 'Copay',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),

    },
    {
      dataField: 'tpPayment',
      text: 'Insurance Payment',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),

    },
    {
      dataField: 'totalPayment',
      text: 'Total Paid',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),

    },
    {
      dataField: 'estWACRetailCost',
      text: 'Est WAC Retail Cost',
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),

    },

    {
      dataField: '_340BDispensingFee',
      text: 'Dispense Fee',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),

    },

    {
      dataField: 'claimType',
      text: 'Claim Type',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'claimSubType',
      text: 'Claim Sub Type',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'reason',
      text: 'Reason',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'subReason',
      text: 'Sub Reason',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'replenishmentPercent',
      text: 'Replenishment %',
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'replenishmentPO',
      text: 'Replenishment PO #',
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },
    {
      dataField: 'replenishmentInvoiceNumber',
      text: 'Replenishment Invoice #',
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),

    },



  ];
  const { filters: colFilter, backUpData } = state;

  return (
    <div>
    <h5 className="f-16 text-primary font-weight-700">
       {filters?.statusTypeId == 2 ? 'Non-Replenished Claims Report Count' : filters?.statusTypeId == 1 ? 'Replenished  Claims Report Count' : 'Replenished and Non-Replenished Claims Report Count' } ({totalSize})
    </h5>
    <hr />
    <div
      className="table-card scroll-table position-relative border-0 rounded pt-0"
      fixed-height={tableDataBackup.length > 0 ? 'fixed-height' : 'default'}
    >
      <ReactStrapTable
        id='ReportReplenishedTable-table'
        fixedColumn
        data={tableDataBackup}
       //loading={loading}
        columns={autoselectlist1.length > 0 ? maincol1 : mainCol}
        onPageSizeChange={onPageSizeChange}
        pageSize={filters.pageSize}
        AllExport={AllExport}
        slelectedExport={slelectedExportReplenishedcoloumms}
        hasPagination
        onPageChange={onHandlePageChange}
        currentPage={filters.currentPage}
        totalRecords={totalSize}
        handleSort={handleSort}
        filters={filters}
        onFilterCancel={handleFilterCancel}
        hasExportPermission={hasExportPermission}
        onSearchColumnFilters={handleSearchColumnFilters}
        onSelectColoums={handleselectColoums}
        autoselectlist1={autoselectlist1}
        hasColselect={true}
        disableSelectedColumn={disableSelectedColumn}
        toggleSider={toggleSider}
        enabletogglesider={true}
        collapseSider={collapseSider}
      />
      <Modal
        isOpen={coloumselect}
        toggle={handleselectColoums}
        size='lg'
        className='lg'
      >
        <ModalHeader toggle={handleselectColoums}>
          Column Selector
        </ModalHeader>
        <ModalBody>
           <DragDrop cancalcolselect={handleselectColoums} refetch={handleselectColoums} reloadautocolum={handlAutocoloms} modulename={modulename} />
          {/* <DragDrop cancalcolselect={handleselectColoums} refetch={handleFilterCancel} reloadautocolum={handlAutocoloms} modulename={modulename} /> */}
        </ModalBody>
      </Modal>
    </div>
    </div>

  )
}

export default ReportReplenishedTable;
